import { Sizes } from '../constants/size';
import type { IconProps } from '../types/icon-props';

export const MobileFilled = (props: IconProps) => {
  const { size = 'md', fill = '#9696a0', ...rest } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      {...rest}
      fill={fill}
    >
      <path fill="none" d="M0 0h16v16H0z" />
      <g>
        <path d="M12 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zM4 13V3h8v10z" />
      </g>
    </svg>
  );
};

MobileFilled.displayName = 'MobileFilled';
